import { observable, decorate, action } from 'mobx';

class Companies {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  companies = [];

  currentCompanyId = null;

  isCompaniesLoading = true;

  isCompanyLoading = false;

  subscribe = () => {
    this.rootStore.socket.subscribe('company_list', ({ data }) => {
      this.updateCompanyList(data);
      this.refreshData();
    });
    this.rootStore.socket.subscribe('successful_save', ({ data }) => {
      const authStore = this.rootStore.authStore;
      const callStatsStore = this.rootStore.callsStats;
      authStore.switchUser(data)
      this.refreshData();
      this.setIsCompanyLoading(false);
      callStatsStore.setLoading(false);
      authStore.setFirstLaunch(true);
    });
  };

  setIsAllCompaniesLoading = (value) => {
    this.isCompaniesLoading = value;
  };

  setIsCompanyLoading = (value) => {
    this.isCompanyLoading = value;
  };

  refreshData = () => {
    this.setIsAllCompaniesLoading(false);
    this.rootStore.controlTableStore.getDevices();
    this.rootStore.callsStats.getCallsStats();
    this.rootStore.logsStore.getInitialData();
  };

  updateCompanyList = (data) => {
    this.companies = data.company_list;
    this.currentCompanyId = data.selected_company;
  };

  setNewCompany = (companyId) => {
    const callStatsStore = this.rootStore.callsStats;
    callStatsStore.setLoading(true);
    this.setIsCompanyLoading(true);
    this.rootStore.socket.send({
      activity: 'action_selected_company',
      company_id: companyId,
    });
    this.currentCompanyId = companyId;
  };

  getAllCompanies = () => {
    this.setIsAllCompaniesLoading(true);
    this.rootStore.socket.send({ activity: 'action_company_list' });
  };

  clear = () => {
    this.companies = [];
    this.currentCompanyId = null;
    this.isCompaniesLoading = true;
    this.isCompanyLoading = false;
  }
}

export default decorate(Companies, {
  companies: observable,
  currentCompanyId: observable,
  isCompaniesLoading: observable,
  isCompanyLoading: observable,
  updateCompanyList: action,
  subscribe: action,
  setNewCompany: action,
  getAllCompanies: action,
  setIsAllCompaniesLoading: action,
  clear: action,
});
